var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _rect6, _polygon, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalEnrollmentByGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#fff;}.d{fill:#f7b64c;}.e{fill:#66c6b9;}.f{fill:#f3705a;}.g{fill:#adb3ba;}.h{fill:#415a6b;}.i{fill:url(#b);opacity:.35;}.j{fill:#ced6e0;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 39.44,
    y1: 78.83,
    x2: 47.44,
    y2: 2.33,
    gradientTransform: "translate(0 86) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19ff55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007f0f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m.3,33.02C.3,21.82.3,16.22,2.48,11.94c1.92-3.76,4.98-6.82,8.74-8.74,4.28-2.18,9.88-2.18,21.08-2.18h22c11.2,0,16.8,0,21.08,2.18,3.76,1.92,6.82,4.98,8.74,8.74,2.18,4.28,2.18,9.88,2.18,21.08v22c0,11.2,0,16.8-2.18,21.08-1.92,3.76-4.98,6.82-8.74,8.74-4.28,2.18-9.88,2.18-21.08,2.18h-22c-11.2,0-16.8,0-21.08-2.18-3.76-1.92-6.82-4.98-8.74-8.74C.3,71.82.3,66.22.3,55.02v-22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m55.44,76.11H22.89l-12.96-12.96V14.04c0-2.34,1.79-4.14,4.14-4.14h41.38c2.34,0,4.14,1.79,4.14,4.14v57.93c0,2.34-1.79,4.14-4.14,4.14Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 29.79,
    y: 66.59,
    width: 23.31,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 16.55,
    y: 55.14,
    width: 36.41,
    height: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 16.55,
    y: 43.56,
    width: 36.41,
    height: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 38.2,
    y: 31.97,
    width: 14.9,
    height: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 38.2,
    y: 20.39,
    width: 14.9,
    height: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m22.89,76.11v-8.83c0-2.34-1.79-4.14-4.14-4.14h-8.83l12.96,12.96Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 25.38,
    cy: 20.94,
    r: 4.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m34.07,35.97h-17.52c0-4.83,3.86-8.83,8.83-8.83s8.69,4,8.69,8.83Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m58.2,24.11c.41.28.97.14,1.24-.28,2.07-2.9,4-7.59,4.97-10.21.14-.28.41-.41.55-.55.28-.14.55,0,.83.14l2.34,1.52c.41.28.97.14,1.24-.28s.14-.97-.28-1.24l-2.34-1.52c-.69-.41-1.52-.55-2.34-.28-.83.28-1.38.83-1.66,1.66-.97,2.48-2.9,7.17-4.83,9.79-.28.41-.14.97.28,1.24h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m51.58,51c3.17-3.03,5.93-6.34,8.14-10.07l9.24-14.76-6.62-4.28-9.24,14.76c-2.34,3.72-4.14,7.59-5.52,11.72l4,2.62Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m48,46.87c-.14.55-.41.97-.55,1.52l4.14,2.62c.41-.41.69-.83,1.1-1.1l-4.69-3.03Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m68.68,11.84l-6.34,10.07,6.76,4.28,6.34-10.21c1.24-1.93.55-4.28-1.24-5.52h0c-1.79-1.1-4.28-.55-5.52,1.38Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 64.76,
    y: 20.17,
    width: 1.93,
    height: 8,
    transform: "translate(10.25 66.9) rotate(-57.8)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "47.86 48.66 45.37 50.87 44.69 57.49 50.34 54.04 51.17 50.87 47.86 48.66"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 47.86,
    cy: 52.38,
    r: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalEnrollmentByGender);
export default __webpack_public_path__ + "static/media/total_enrollment_by_gender.8364657bd324727d7c4e598814c6c629.svg";
export { ForwardRef as ReactComponent };